export default __webpack_public_path__ + "static/media/09_photo.ac21e22b.jpg";